import "../sass/style.scss";
// import HeaderHeight from "./headerHeight";
import contactFormCheck from "./contactFormCheck";
import * as header from "./header";
import scrollEffect from "./scrollEffect";
import slider from "./slider";
import smallResponsive from "./smallResponsive";
import tab from "./tab";

smallResponsive();

// HeaderHeight();
contactFormCheck();

header.toggleMenu();

scrollEffect();

tab();

// smoothScroll();

slider();
